<template>
  <div class="teachers-settings-container">
    <div class="content-header">
      <div class="header-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <h1>Tanárok</h1>
      <p>Tanárok listázása és kezelése</p>
    </div>

    <div class="filters-section">
      <div class="search-group">
        <div class="search-input-wrapper">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          <input 
            type="text" 
            class="modern-input" 
            placeholder="Keresés név alapján..." 
            v-model="searchQuery"
            @keyup.enter="fetchTeachers()"
            @input="fetchTeachers()"
          />
        </div>
      </div>
    </div>

    <div class="table-section">
      <div class="table-header">
        <h3>Tanárok listája</h3>
        <span class="count-badge">{{ teachers.length }} tanár</span>
      </div>
      
      <div class="modern-table-container">
        <table class="modern-table">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Tanár neve
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  Email
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                  Hozzárendelt csoportok
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  Műveletek
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
                  </svg>
                  Aszisztens
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="teacher in filteredTeachers" 
              :key="teacher.id"
              class="table-row"
            >
              <td class="name-cell">
                <div class="cell-content">
                  <div class="teacher-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <span class="teacher-name">{{ teacher.family_name }} {{ teacher.sure_name }}</span>
                  <span v-if="teacher.role === 900 || teacher.role === 999" class="badge bg-danger ms-2" style="font-size: 0.75rem;">Admin</span>
                </div>
              </td>
              <td class="email-cell">
                <span class="teacher-email">{{ teacher.email }}</span>
              </td>
              <td class="groups-cell">
                <div class="assigned-groups mb-1">
                  <span class="text-muted small d-block"><strong>Oktatja:</strong></span>
                  <span 
                    v-for="group in getTeacherGroups(teacher)" 
                    :key="'t-'+group.id"
                    class="group-badge"
                  >
                    {{ group.name }}
                  </span>
                  <span v-if="getTeacherGroups(teacher).length === 0" class="no-groups">
                    Nincs oktatott csoport
                  </span>
                </div>
                <div class="assigned-groups">
                  <span class="text-muted small d-block"><strong>Táncolja:</strong></span>
                  <span 
                    v-for="group in getTeacherDancerGroups(teacher)" 
                    :key="'d-'+group.id"
                    class="group-badge"
                    style="background-color: #e2e8f0; color: #334155; border: 1px solid #cbd5e1;"
                  >
                    {{ group.name }}
                  </span>
                  <span v-if="getTeacherDancerGroups(teacher).length === 0" class="no-groups">
                    Nincs táncolt csoport
                  </span>
                </div>
              </td>
              <td class="actions-cell">
                <div class="d-flex flex-column gap-1">
                  <button
                    class="action-btn assign-btn"
                    @click="openGroupAssignmentmdl(teacher)"
                    title="Oktatói csoportok"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 5v14m7-7H5"/>
                    </svg>
                    Oktatási csoport
                  </button>
                  <button
                    class="action-btn assign-btn"
                    style="background-color: #6366f1; color: white;"
                    @click="openDancerAssignmentmdl(teacher)"
                    title="Táncos csoportok"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                    </svg>
                    Táncos csoport
                  </button>
                </div>
              </td>
              <td class="assistant-cell">
                <label class="assistant-toggle">
                  <input
                    type="checkbox"
                    :checked="teacher.is_assistant"
                    @change="toggleAssistant(teacher)"
                  />
                  <span class="assistant-label">{{ teacher.family_name }} {{ teacher.sure_name }}</span>
                </label>
              </td>
            </tr>
          </tbody>
       </table>
       </div>
     </div>

    <!-- Group Assignment mdl (Teacher) -->
    <div v-if="showAssignmentmdl" class="mdl-overlay" @click="closeGroupAssignmentmdl">
      <div class="mdl-content" @click.stop>
        <div class="mdl-header">
          <h3>Oktatói csoport hozzárendelés - {{ selectedTeacher.family_name }} {{ selectedTeacher.sure_name }}</h3>
          <button class="close-btn" @click="closeGroupAssignmentmdl">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="mdl-body">
          <div class="groups-section">
            <h4>Elérhető csoportok (Oktatóként)</h4>
            <div class="groups-list">
              <div 
                v-for="group in availableGroups" 
                :key="group.id"
                class="group-item"
                :class="{ assigned: isGroupAssigned(group.id) }"
              >
                <div class="group-info">
                  <span class="group-name">{{ group.name }}</span>
                  <span class="group-schedule">{{ group.def_name }}</span>
                </div>
                <button 
                  v-if="!isGroupAssigned(group.id)"
                  class="assign-group-btn"
                  @click="assignGroupToTeacher(group.id)"
                >
                  Hozzárendelés
                </button>
                <button 
                  v-else
                  class="remove-group-btn"
                  @click="removeGroupFromTeacher(group.id)"
                >
                  Eltávolítás
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Group Assignment mdl (Dancer) -->
    <div v-if="showDancerAssignmentmdl" class="mdl-overlay" @click="closeDancerAssignmentmdl">
      <div class="mdl-content" @click.stop>
        <div class="mdl-header">
          <h3>Táncos csoport hozzárendelés - {{ selectedTeacher.family_name }} {{ selectedTeacher.sure_name }}</h3>
          <button class="close-btn" @click="closeDancerAssignmentmdl">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="mdl-body">
          <div class="groups-section">
            <h4>Elérhető csoportok (Táncosként)</h4>
            <div class="groups-list">
              <div 
                v-for="group in availableGroups" 
                :key="group.id"
                class="group-item"
                :class="{ assigned: isDancerGroupAssigned(group.id) }"
              >
                <div class="group-info">
                  <span class="group-name">{{ group.name }}</span>
                  <span class="group-schedule">{{ group.def_name }}</span>
                </div>
                <button 
                  v-if="!isDancerGroupAssigned(group.id)"
                  class="assign-group-btn"
                  style="background-color: #6366f1;"
                  @click="assignTeacherAsDancer(group.id)"
                >
                  Felvétel táncosként
                </button>
                <button 
                  v-else
                  class="remove-group-btn"
                  @click="removeTeacherAsDancer(group.id)"
                >
                  Eltávolítás
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        teachers: [],
        groups: [],
        searchQuery: '',
        showAssignmentmdl: false,
        showDancerAssignmentmdl: false,
        selectedTeacher: null,
        availableGroups: []
      };
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      filteredTeachers() {
        if (!this.searchQuery) {
          return this.teachers;
        }
        return this.teachers.filter(teacher => 
          teacher.family_name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          teacher.sure_name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          teacher.email.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },
    methods: {
      async fetchTeachers() {
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/info`);
          const data = await response.json();
          this.teachers = data.teachers || [];
        } catch (error) {
          console.error('Error fetching teachers:', error);
        }
      },
      async fetchGroups() {
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/groups/info`);
          const data = await response.json();
          this.groups = data.groups || [];
        } catch (error) {
          console.error('Error fetching groups:', error);
        }
      },
      getTeacherGroups(teacher) {
        return this.groups.filter(group => 
          teacher.assigned_groups && teacher.assigned_groups.includes(group.id)
        );
      },
      getTeacherDancerGroups(teacher) {
        return this.groups.filter(group => 
          teacher.dancer_groups && teacher.dancer_groups.includes(group.id)
        );
      },
      openGroupAssignmentmdl(teacher) {
        this.selectedTeacher = teacher;
        this.availableGroups = this.groups;
        this.showAssignmentmdl = true;
      },
      closeGroupAssignmentmdl() {
        this.showAssignmentmdl = false;
        this.selectedTeacher = null;
        this.availableGroups = [];
      },
      openDancerAssignmentmdl(teacher) {
        this.selectedTeacher = teacher;
        this.availableGroups = this.groups;
        this.showDancerAssignmentmdl = true;
      },
      closeDancerAssignmentmdl() {
        this.showDancerAssignmentmdl = false;
        this.selectedTeacher = null;
        this.availableGroups = [];
      },
      isGroupAssigned(groupId) {
        return this.selectedTeacher && 
               this.selectedTeacher.assigned_groups && 
               this.selectedTeacher.assigned_groups.includes(groupId);
      },
      isDancerGroupAssigned(groupId) {
        return this.selectedTeacher && 
               this.selectedTeacher.dancer_groups && 
               this.selectedTeacher.dancer_groups.includes(groupId);
      },
      async assignTeacherAsDancer(groupId) {
        if (!this.selectedTeacher) return;
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/assign-as-dancer`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              teacher_id: this.selectedTeacher.id,
              group_id: groupId
            })
          });
          
          if (response.ok) {
            if (!this.selectedTeacher.dancer_groups) {
              this.selectedTeacher.dancer_groups = [];
            }
            if (!this.selectedTeacher.dancer_groups.includes(groupId)) {
              this.selectedTeacher.dancer_groups.push(groupId);
            }
            await this.fetchTeachers();
          }
        } catch (error) {
          console.error('Error assigning teacher as dancer:', error);
        }
      },
      async removeTeacherAsDancer(groupId) {
        if (!this.selectedTeacher) return;
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/remove-as-dancer`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              teacher_id: this.selectedTeacher.id,
              group_id: groupId
            })
          });

          if (response.ok) {
            if (this.selectedTeacher.dancer_groups) {
              this.selectedTeacher.dancer_groups = this.selectedTeacher.dancer_groups.filter(id => id !== groupId);
            }
            await this.fetchTeachers();
          }
        } catch (error) {
          console.error('Error removing teacher as dancer:', error);
        }
      },
      async assignGroupToTeacher(groupId) {
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/assign-group`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              teacher_id: this.selectedTeacher.id,
              group_id: groupId
            })
          });
          
          if (response.ok) {
            if (!this.selectedTeacher.assigned_groups) {
              this.selectedTeacher.assigned_groups = [];
            }
            this.selectedTeacher.assigned_groups.push(groupId);
            await this.fetchTeachers();
          }
        } catch (error) {
          console.error('Error assigning group to teacher:', error);
        }
      },
       async removeGroupFromTeacher(groupId) {
         try {
           const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/remove-group`, {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
             },
             body: JSON.stringify({
               teacher_id: this.selectedTeacher.id,
               group_id: groupId
             })
           });

           if (response.ok) {
             // Remove group from teacher's assigned groups
             if (this.selectedTeacher.assigned_groups) {
               this.selectedTeacher.assigned_groups = this.selectedTeacher.assigned_groups.filter(id => id !== groupId);
             }

             // Update the teacher in the main teachers array
             const teacherIndex = this.teachers.findIndex(t => t.id === this.selectedTeacher.id);
             if (teacherIndex !== -1) {
               this.teachers[teacherIndex] = { ...this.selectedTeacher };
             }
           } else {
             console.error('Failed to remove group from teacher');
           }
         } catch (error) {
           console.error('Error removing group from teacher:', error);
         }
       },
       async toggleAssistant(teacher) {
         try {
           const response = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/set-assistant`, {
             method: 'POST',
             headers: { 'Content-Type': 'application/json' },
             body: JSON.stringify({ teacher_id: teacher.id, enabled: !teacher.is_assistant }),
           });
           if (response.ok) {
             teacher.is_assistant = !teacher.is_assistant;
           } else {
             console.error('Failed to update teacher assistant status');
           }
         } catch (error) {
           console.error('Error toggling teacher assistant:', error);
         }
       }
     },
     mounted() {
       this.fetchTeachers();
       this.fetchGroups();
     }
  };
  </script>
  
  <style scoped>
  .teachers-settings-container {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    background: var(--color-background);
    min-height: 100vh;
  }

  .content-header {
    text-align: center;
    margin-bottom: 2rem;
    padding: 2rem;
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
  }

  .header-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    background: var(--button-primary);
    border-radius: 16px;
    margin-bottom: 1rem;
    color: white;
  }

  .content-header h1 {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--color-text);
    margin: 0 0 0.5rem 0;
  }

  .content-header p {
    color: var(--color-text-muted);
    font-size: 1.1rem;
    margin: 0;
  }

  .filters-section {
    display: flex;
    gap: 1.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    align-items: flex-end;
  }

  .search-group {
    flex: 1;
    min-width: 300px;
  }

  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .search-input-wrapper svg {
    position: absolute;
    left: 1rem;
    color: var(--text-muted);
    z-index: 1;
  }

  .modern-input {
    width: 100%;
    padding: 0.875rem 1rem 0.875rem 3rem;
    border: 2px solid var(--color-border);
    border-radius: 12px;
    background: var(--card-bg);
    color: var(--color-text);
    font-size: 1rem;
    transition: all 0.2s ease;
  }

  .modern-input:focus {
    outline: none;
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .modern-input::placeholder {
    color: var(--text-muted);
  }

  .filter-options {
    display: flex;
    align-items: center;
  }

  .checkbox-group {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .modern-checkbox {
    display: none;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    font-weight: 500;
    color: var(--color-text);
    user-select: none;
  }

  .checkbox-custom {
    width: 20px;
    height: 20px;
    border: 2px solid var(--color-border);
    border-radius: 6px;
    background: var(--card-bg);
    position: relative;
    transition: all 0.2s ease;
  }

  .modern-checkbox:checked + .checkbox-label .checkbox-custom {
    background: var(--primary-blue);
    border-color: var(--primary-blue);
  }

  .modern-checkbox:checked + .checkbox-label .checkbox-custom::after {
    content: '';
    position: absolute;
    left: 6px;
    top: 2px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  .table-section {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    margin-bottom: 2rem;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid var(--color-border);
    background: var(--bg-secondary);
  }

  .table-header h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--color-text);
  }

  .count-badge {
    background: var(--button-primary);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 600;
  }

  .modern-table-container {
    overflow-x: auto;
  }

  .modern-table {
    width: 100%;
    border-collapse: collapse;
  }

  .modern-table th {
    background: var(--bg-secondary);
    padding: 1rem 1.5rem;
    text-align: left;
    font-weight: 600;
    color: var(--color-text);
    border-bottom: 1px solid var(--color-border);
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .th-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .th-content svg {
    color: var(--primary-blue);
  }

  .table-row {
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .table-row:hover {
    background: var(--hover-bg);
  }

  .table-row td {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid var(--color-border);
    vertical-align: middle;
  }

  .name-cell {
    font-weight: 500;
  }

  .cell-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .teacher-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: var(--button-primary);
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .teacher-name {
    color: var(--color-text);
    font-weight: 500;
  }

  .teacher-email {
    color: var(--color-text-muted);
    font-size: 0.9rem;
  }

  .assigned-groups {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .no-groups {
    color: var(--color-text-muted);
    font-style: italic;
    font-size: 0.9rem;
  }

  .actions-cell {
    text-align: center;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: var(--button-primary);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .action-btn:hover {
    background: var(--primary-blue);
    transform: translateY(-1px);
  }

  .assign-btn {
    background: var(--success);
  }

  .assign-btn:hover {
    background: #059669;
  }

  /* mdl Styles */
  .mdl-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .mdl-content {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-lg);
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow: hidden;
  }

  .mdl-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid var(--color-border);
    background: var(--bg-secondary);
  }

  .mdl-header h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--color-text);
  }

  .close-btn {
    background: none;
    border: none;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  .close-btn:hover {
    background: var(--hover-bg);
    color: var(--color-text);
  }

  .mdl-body {
    padding: 2rem;
    max-height: 60vh;
    overflow-y: auto;
  }

  .groups-section h4 {
    margin: 0 0 1rem 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--color-text);
  }

  .groups-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: var(--card-bg);
    border: 2px solid var(--color-border);
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .group-item.assigned {
    border-color: var(--success);
    background: rgba(34, 197, 94, 0.1);
  }

  .group-info {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .group-name {
    font-weight: 600;
    color: var(--color-text);
  }

  .group-schedule {
    font-size: 0.875rem;
    color: var(--color-text-muted);
  }

  .assign-group-btn,
  .remove-group-btn {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .assign-group-btn {
    background: var(--success);
    color: white;
  }

  .assign-group-btn:hover {
    background: #059669;
  }

  .remove-group-btn {
    background: var(--error);
    color: white;
  }

  .remove-group-btn:hover {
    background: #dc2626;
  }

  .group-cell {
    text-align: center;
  }

  .group-badge {
    display: inline-block;
    background: var(--success);
    color: white;
    padding: 0.375rem 0.75rem;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
  }
  
  .multiplier-cell {
    text-align: center;
  }
  
  .multiplier-input {
    width: 80px;
    padding: 0.5rem;
    border: 2px solid var(--color-border);
    border-radius: 8px;
    background: var(--card-bg);
    color: var(--color-text);
    text-align: center;
    font-size: 0.875rem;
    font-weight: 500;
  }
  
  .multiplier-input:focus {
    outline: none;
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
@media (max-width: 768px) {
      .teachers-settings-container {
        padding: 1rem;
      }
  
      .filters-section {
        flex-direction: column;
        align-items: stretch;
      }
  
      .search-group {
        min-width: auto;
      }
  
      .modern-table th,
      .table-row td {
        padding: 0.75rem 1rem;
      }
  
      .table-header {
        padding: 1rem 1.5rem;
      }
  
      .mdl-content {
        width: 95%;
        margin: 1rem;
      }
  
      .group-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
      }
  
      .assign-group-btn,
      .remove-group-btn {
        align-self: flex-end;
      }
    }
  
    .assistant-cell {
      text-align: center;
    }
 
   .assistant-toggle {
     display: flex;
     align-items: center;
     justify-content: center;
     gap: 0.5rem;
     cursor: pointer;
     font-weight: 500;
     color: var(--color-text);
     user-select: none;
     font-size: 0.875rem;
   }
 
   .assistant-toggle input[type="checkbox"] {
     width: 18px;
     height: 18px;
     accent-color: var(--primary-blue);
     cursor: pointer;
   }
 
   .assistant-label {
     white-space: nowrap;
   }
  </style>
  